import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './polyfill';
import { icons } from './assets/icons';

React.icons = icons;

// Persist a deep-linked initiative before any redirect can drop it from the URL
const urlInitiativeId = new URLSearchParams(window.location.search).get('initiative_id');
if (urlInitiativeId) {
  sessionStorage.setItem('initiative_id', urlInitiativeId);
}

Sentry.init({
  dsn: 'https://de884506f01b40a4a610ca2fda262e0d@o445536.ingest.sentry.io/5422084',

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  integrations: [new Sentry.Replay()],

  environment: process.env.NODE_ENV || 'development',
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
